import { useBreakpoints } from "../../utils/use-breakpoints"
import { Flex, FlexProps, Group, GroupProps } from "@mantine/core"
import { SuspenseWithErrorBoundary } from "../suspense"
import { NavGroup, NavGroupProps } from "../NavGroup"
import { ScrollContainer } from "../scroll-container"
import { DottedMenuProps } from "../dotted-menu"
import { forwardRef } from "react"
import { useLocation } from "@tanstack/react-router"
import { ResponsiveDottedMenuActions } from "../responsive-dotted-menu-actions"

interface Props
  extends React.PropsWithChildren,
    Pick<NavGroupProps, "crumbOverride"> {
  buttonGroupProps?: GroupProps
  dottedMenuProps?: DottedMenuProps
  navGroupProps?: GroupProps
  infoDescription?: string
  titleGroupProps?: GroupProps
  crumbOverride?: () => React.ReactElement
  scrollContainerProps?: FlexProps
}

export const Page = forwardRef<HTMLDivElement, Props>(
  (
    {
      children,
      buttonGroupProps,
      crumbOverride,
      dottedMenuProps,
      titleGroupProps,
      navGroupProps,
      scrollContainerProps,
    },
    ref
  ) => {
    const { xs, sm } = useBreakpoints()
    const location = useLocation().pathname
    const path = location.split("?")[0]

    return (
      <Flex mah="100%" h="100%" direction="column" ref={ref}>
        <Group
          justify="space-between"
          align="center"
          wrap="nowrap"
          px={sm || xs ? "sm" : "md"}
          py="md"
          h={xs || sm ? undefined : "60px"}
          {...titleGroupProps}
        >
          <NavGroup crumbOverride={crumbOverride} {...navGroupProps} />
          <ResponsiveDottedMenuActions
            buttonGroupProps={buttonGroupProps}
            dottedMenuProps={dottedMenuProps}
          />
        </Group>

        <ScrollContainer
          px={sm || xs ? "sm" : "md"}
          mb="md"
          direction="column"
          flex={1}
          {...scrollContainerProps}
        >
          <SuspenseWithErrorBoundary>{children}</SuspenseWithErrorBoundary>
        </ScrollContainer>
      </Flex>
    )
  }
)
